export default "__VITE_ASSET__fqoRbwHt__"